import {
  CREDIT_LIMIT_DANGER_THRESHOLD,
  CREDIT_LIMIT_WARNING_THRESHOLD,
} from '@/constants/billing';

export type CreditLimitStatusType = 'warning' | 'danger' | null;

export function computeEffectiveCreditLimit(
  creditLimit: number | null | undefined,
  creditLimitExcess: number | null | undefined,
) {
  if (creditLimit == null) return null;
  return creditLimit + (creditLimitExcess ?? 0);
}

export function computeCreditLimitStatus(
  creditsUsed: number | null | undefined,
  creditLimit: number | null | undefined,
): CreditLimitStatusType {
  if (!creditLimit || creditsUsed == null) return null;
  const ratio = creditsUsed / creditLimit;
  if (ratio >= CREDIT_LIMIT_DANGER_THRESHOLD) return 'danger';
  if (ratio >= CREDIT_LIMIT_WARNING_THRESHOLD) return 'warning';
  return null;
}
